import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanTags'
})
export class CleanTagsPipe implements PipeTransform {

  transform(value: string, args?: any): string {

    if (value) {
      let resp: string = value;
      resp = resp.replace(/<[^>]*>/g, '');
      return resp;
    }

    return '';

  }

}



// WEBPACK FOOTER //
// /app/src/app/pipes/clean-tags.pipe.ts